import { useState } from "react";
import { navLinks } from "../../../mocks/portalData";

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  return (
    <header id="top" className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-[1320px] items-center justify-between gap-4 px-4 md:px-6">
        <div className="flex items-center gap-5">
          <h1 className="flex items-center gap-2 whitespace-nowrap">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-sm font-black text-background-50">
                52
              </span>
              <span className="hidden sm:block">
                <span className="block font-heading text-lg font-black leading-none tracking-tight text-foreground-950">
                  黑料
                </span>
                <span className="mt-0.5 block text-[10px] font-medium uppercase tracking-[0.2em] text-foreground-500">
                  Index Archives
                </span>
              </span>
            </a>
          </h1>
          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.key}
                href={link.key}
                className={
                  "whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors " +
                  (link.active
                    ? "font-bold text-foreground-950"
                    : "font-medium text-foreground-600 hover:text-foreground-950")
                }
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <form
            className="hidden items-center gap-2 rounded-md border border-background-300/70 bg-background-100 px-3 py-2 lg:flex"
            onSubmit={(e) => e.preventDefault()}
          >
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索人物 / 事件 / 类型…"
              className="w-44 bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
          </form>
          <button
            type="button"
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/70 text-foreground-700 lg:hidden"
          >
            <i className="ri-search-line text-base"></i>
          </button>
          <button
            type="button"
            aria-label="发布新瓜线索"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 hover:bg-primary-600 md:flex"
          >
            <i className="ri-fire-fill text-sm"></i>
            发布线索
          </button>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen(!open)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 py-3 md:hidden">
          <div className="grid gap-1">
            {navLinks.map((link) => (
              <a
                key={link.key}
                href={link.key}
                onClick={() => setOpen(false)}
                className={
                  "rounded-md px-3 py-2.5 text-sm " +
                  (link.active
                    ? "bg-background-100 font-bold text-foreground-950"
                    : "font-medium text-foreground-600")
                }
              >
                {link.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            className="mt-3 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50"
          >
            <i className="ri-fire-fill text-sm"></i>
            发布线索
          </button>
        </div>
      )}
    </header>
  );
}